import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { BACKEND_API_URL } from "../../config";


// GET Employees List
export const fetchInitialState = createAsyncThunk(
  'LicenseStates/fetch', 
  async (data, { getState, dispatch }) => {
    const token = getState().navigator.token;
      try {
        const response = await fetch(`${BACKEND_API_URL}/api/onboarding/license_states?token=${token}`);
        if (!response.ok) {
          throw new Error('Failed to fetch initial state');
        }
        const response_data = await response.json();
        // console.log(response_data);
        return response_data;
      } catch (error) {
        console.error('Error fetching initial state:', error);
        return []
      }
    
  })


// Create New State
export const SubmitLicenseStates = createAsyncThunk(
    'LicenseStates/submit',
    async (data, { getState, dispatch, rejectWithValue }) => {
      // console.log(data);
        try {
          const currentStep = getState().navigator.currentStep;
          const token = getState().navigator.token;

          if (data.length === 0) {
            // console.log("No data to submit");
            return rejectWithValue("Select at least one state");
          }
          const response = await fetch(`${BACKEND_API_URL}/api/onboarding/license_states?token=${token}`, {
            method: 'POST',
            body: JSON.stringify({'state_names': data, 'current_step': currentStep }),
            headers: {
                'Content-Type': 'application/json',
            }
        });
          const response_data =  await response.json();
          // Handle the response data
          // console.log('Form submitted successfully', response_data);
    
          // Return the response data for the fulfilled action
          // dispatch(updateUserId({ userId: response_data['id']}));
          return response_data.data;
        } catch (error) {
          // Handle submission errors
          console.error('Form submission error', error);
          // Throw an error for the rejected action
          return rejectWithValue(error.message);
        }
      }
)


// Slice
const initialState = {
  data: [], // list of state names
  status: 'idle', // 'idle' | 'loading' | 'success' | 'failed'
  loading: false,
  error: null,
  formErrors: {},
}

export const licenseStatesSlice = createSlice({
    name: 'LicenseStates',
    initialState,
    reducers: {
      addLicenseState: (state, action) => {
        state.data.push(action.payload);
      },
      removeLicenseState: (state, action) => {
        let index = state.data.findIndex(obj => obj === action.payload);
        // Delete the object if it exists
        if (index !== -1) {
            state.data.splice(index, 1);
        }
      },
    },
    extraReducers: (builder) => {
        builder
          // CREATE or UPDATE
          .addCase(SubmitLicenseStates.pending, (state) => {
            state.loading = true;
          })
          .addCase(SubmitLicenseStates.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
          })
          .addCase(SubmitLicenseStates.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })

          // GET
          .addCase(fetchInitialState.pending, (state) => {
            state.loading = true;
          })
          .addCase(fetchInitialState.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
          })
          .addCase(fetchInitialState.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })
      },
  });


export const { addLicenseState, removeLicenseState } = licenseStatesSlice.actions;

export default licenseStatesSlice.reducer;
  